'use strict';
import {reduxList} from '../redux/projectReqList';

/** @type {ReduxObservableListActions} **/
export const projectRequirementListActions = reduxList.actions;



// WEBPACK FOOTER //
// ./src/js/requirements/actions/projectListActions.js